import { useUpperSeo } from "../../../../../hooks";

import { Container } from "../../../../../components";
import { Filter } from "../Filter/Filter";

import { Section } from "../../../../../components/common/Section/Section.styled";
import { ContainerFilter, Text, Title, Wrapper } from "./Head.styled";

export const Head = () => {
  const { title, createDescMarkup } = useUpperSeo();

  return (
    <Section variant="startProxy">
      <Container isBig={true}>
        <Wrapper>
          <Title>{title}</Title>

          <Text dangerouslySetInnerHTML={createDescMarkup()} />

          <ContainerFilter>
            <Filter />
          </ContainerFilter>
        </Wrapper>
      </Container>
    </Section>
  );
};
